var React = require('react');

function ExpandArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33.17 17.17l-9.17 9.17-9.17-9.17-2.83 2.83 12 12 12-12z","key":0}),React.createElement("path",{"d":"M0 0h48v48h-48z","fill":"none","key":1})]);
}

ExpandArrow.defaultProps = {"height":"48","viewBox":"0 0 48 48","width":"48"};

module.exports = ExpandArrow;

ExpandArrow.default = ExpandArrow;
